module.exports = __webpack_public_path__ + "img/ico_info_yellow.981e2fc6.svg";